import { gql } from "graphql-request";

const GetVacationsQuery = gql`
  query GetVacations {
    GetVacations {
      id
      comment
      startDate
      endDate
      responseStatus
      response
      applicationStartDate
      applicationEndDate
      userContractId
      userContract {
        id
        status
        initialDate
        businessId
        contractType
        business {
          businessName
          id
          name
          rut
          businessRepresentatives {
            id
            rut
          }
          address {
            address
            commune
            country
          }
        }
      }
      requestDate
      responseDate
      isHistoric
      halfDay
      responseStatusValues
      progressiveDays
      legalDays
      additionalDays
      voucherFile
      userId
      user {
        id
        fullname
        firstname
        jobTitle
        rut
        area
        branchOffice
        jobTitleFamily
        email
        businessEmail
        paternalLastname
        avatar {
          id
          url
        }
        userBusinesses {
          id
          businessId
        }
      }
      authorizedBy
    }
  }
`;
export default GetVacationsQuery;
